import _ from '../helper/HelperFunctions';

/**
 * How the force mobile will be working:
 * 
 * @description the force mobile menu class will check when the menu items will wrap under each other (meaning there is no more space) 
 * OR when the menu-button (report an outage) starts to hover over the last menu item. Whenever one of these instances occur the body element
 * will receive the class "force-mobile-menu" which enables the mobile menu.
 */

export default class ForceMobileMenu {
	constructor() {
		this.maximumHeaderHeight = 80;
		this.menuDiv = document.getElementById('vl-header');
		this.headerElement = document.body.querySelector('nav');

		this.setEventListeners();

		var interval = setInterval( this.checkForceMobile.bind( this ), 100 )

		window.addEventListener('load', function(){ clearInterval( interval ) });
		setTimeout(function(){ clearInterval( interval ) }, 5000 )
		this.checkForceMobile()
	}

	/* set the window resize listener to check whether the force mobile class must be added. */
	setEventListeners() {
		window.addEventListener('resize', _.debounce(this.checkForceMobile.bind(this), 50));
	}

	/* check if the force mobile class must be added. */
	checkForceMobile() {
		let widthForceMobileWasAdded;

		var height = this.headerElement.offsetHeight

		this.headerElement.style.height = 'auto';
		
		/* If there is not data attribute yet that the mobile menu was forced, it easy, we add the class if the header exceeds the maximum set height. */
		if ( window.innerWidth <= 1024 || this.headerElement.offsetHeight > this.maximumHeaderHeight && document.body.getAttribute('data-mobile-menu-forced-at-width') === undefined ) {
			widthForceMobileWasAdded = window.innerWidth;
			document.body.classList.add('force-mobile-menu');
			document.body.setAttribute('data-mobile-menu-forced-at-width', widthForceMobileWasAdded);

		}
		/* However, if there is a data attribute set and the window gets bigger than that, we remove the class, check if the header exceeds the maximum height and if so add back the class */
		else if (window.innerWidth >= document.body.getAttribute('data-mobile-menu-forced-at-width')) {
			document.body.classList.remove('force-mobile-menu');
			if (this.headerElement.offsetHeight >= this.maximumHeaderHeight) {
				widthForceMobileWasAdded = window.innerWidth;
				document.body.classList.add('force-mobile-menu');
				document.body.setAttribute('data-mobile-menu-forced-at-width', widthForceMobileWasAdded);
			}
		} else if (this.headerElement.offsetHeight >= this.maximumHeaderHeight) {
			widthForceMobileWasAdded = window.innerWidth;
			document.body.classList.add('force-mobile-menu');
			document.body.setAttribute('data-mobile-menu-forced-at-width', widthForceMobileWasAdded);
		}
		
		this.headerElement.style.height = height + 'px'
	}
}

new ForceMobileMenu();